module.exports = __webpack_public_path__ + "img/ardente.42edaece.jpg";